import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { NavLink } from "react-router-dom";
import { FiMail } from "react-icons/fi";

function Project(props) {
  const { classes } = props;

  return (
    <div className={classes.wrap}>
      <Container className={classes.container} maxWidth="xl">
        <h1>Bạn đang cần làm website - phần mềm ?</h1>
        <NavLink to="/contact">
          <FiMail />
          Liên hệ ngay với chúng tôi
        </NavLink>
      </Container>
    </div>
  );
}

export default withStyles(styles)(Project);
